<twc-sidebar class="height-100" cwTcwSidebarStyles cwSidebarSubmenu [adaptive]="false" #sidebar>
    <twc-sidebar-menu>
        <twc-sidebar-item *ngFor="let item of sideBarItems" [class.sidebar-item__highlighted]="item.highlighted"
            [ngClass]="{'hide-item has-sub-menu': item.hideOnDesktop}" twcTooltip="{{item.keyText | translate}}"
            placement="right" cwBarsTooltip>
            <a *ngIf="item.isVisible" twcSidebarLink routerLinkActive="twc-active" [routerLink]="item.route"
                [routerLinkActiveOptions]="{ exact: true }">
                <twc-icon [shape]="item.icon"></twc-icon>
                <span class="twc-sidebar-text">
                    {{ item.keyText | translate }}
                </span>
                <twc-icon class="sidebar-item-chevron" shape="acc-right" *ngIf="item.options"></twc-icon>
            </a>

            <!-- TODO: remove twc-menu-wrapper and use twc-sidebar-subitem after the complete migration -->
            <twc-menu-wrapper *ngIf="item.isVisible && item.options" class="submenu-container" triggerBy="click">
                <!-- Workaround to display submenu in sidebar: We create a transparent button 
                    that triggers the submenu and adapts its size to the sidebar button -->
                <button class="twc-button twc-button-primary" twcMenuTrigger>-</button>
                <twc-menu [class]="sidebar.expanded ? 'submenu-sidebar-expanded' : 'submenu-sidebar-collapsed'">
                    <ng-container *ngFor="let option of item.options">
                        <twc-menu-option *ngIf="!option.isDivider && option.isVisible" (click)="option.onClick?.()"
                            [ngClass]="{ 'font-bold': option.code === translationService.currentLang}">
                            {{ option.keyText ?? '' | translate }}
                            <twc-icon class="twc-ml-5" *ngIf="translationService.currentLang === option.code"
                                shape="check">
                            </twc-icon>
                        </twc-menu-option>
                        <div *ngIf="option.isDivider" class="menu-sidebar-divider"></div>
                    </ng-container>
                </twc-menu>
            </twc-menu-wrapper>
        </twc-sidebar-item>
    </twc-sidebar-menu>
</twc-sidebar>